module.exports = __webpack_public_path__ + "static/media/customise-in-the-editor.57694248.svg";